// extracted by mini-css-extract-plugin
export default {"icon":"AvatarGroup-module_icon_yodB7","menu-icon":"AvatarGroup-module_menu-icon_bh6kp","menu-item":"AvatarGroup-module_menu-item__jUpZ"};